window.anvil.component('footer', el => {
	const scollToTopBtn = el.querySelector('.js-scroll-top');
	let lastScroll = 0;
	const rootElement = document.documentElement;

	if (scollToTopBtn) {
		function handleScroll() {
			let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

			if (currentScroll <= 0.80 /* && lastScroll <= currentScroll */) {
				lastScroll = currentScroll;
				scollToTopBtn.classList.remove('active');
			} else {
				lastScroll = currentScroll;
				scollToTopBtn.classList.add('active');
			}
		};

		function scrollToTop() {
			rootElement.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		}

		document.addEventListener('scroll', handleScroll);
		scollToTopBtn.addEventListener('click', scrollToTop);
	}

});